import Vue from 'vue';

export async function login(form) {
  const { data } = await Vue.axios.post('/api/auth/login', form);

  return data.data;
}

export async function logout() {
  const { data } = await Vue.axios.post('/api/auth/logout');

  return data.data;
}

export async function checkLogin() {
  const { data } = await Vue.axios.get('/api/auth/login');

  return data.data;
}

export async function user() {
  const { data } = await Vue.axios.get('/api/auth/user');

  return data.data;
}

export async function register(form) {
  const { data } = await Vue.axios.post('/api/auth/register', form);

  return data.data;
}

export async function verifyEmail(form) {
  const { data } = await Vue.axios.post('/api/auth/verify/email', form);

  return data.data;
}

export async function forget(form) {
  const { data } = await Vue.axios.post('/api/auth/forget/password', form);

  return data.data;
}


export async function reset(form) {
  const { data } = await Vue.axios.post('/api/auth/reset/password', form);

  return data.data;
}
